<template>
    <div class="">
        <el-form>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item
                            label="Raktár"
                    >
                        <el-select
                                v-model="storage"
                                value-key="id"
                                style="width: 100%;"
                                filterable
                        >
                            <el-option
                                    v-for="s in storages"
                                    :key="s.id"
                                    :label="s.name"
                                    :value="s"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-table
                v-loading="loading"
                :data="data"
        >

            <el-table-column
                    label="Vevő"
                    prop="customer_name"
                    width="250"
                    show-overflow-tooltip
            >
                <template slot-scope="scope">
                    {{ scope.row.customer_name }}
                </template>

            </el-table-column>


            <el-table-column
                    label="Termék"
                    prop="product_name"
                    width="250"
                    show-overflow-tooltip
            >
                <template slot-scope="scope">
                    {{ scope.row.product_name }}
                </template>
            </el-table-column>

            <el-table-column
                    label="Bizonylatszám"
                    prop="receipt_number"
                    width="120"
            >
                <template slot-scope="scope">
                    {{ scope.row.receipt_number }}
                </template>
            </el-table-column>

            <el-table-column
                    label="Rendelt"
                    prop="ordered_stock"
                    align="right"
            >
                <template slot-scope="scope">
                    {{ scope.row.customer_order_stock }} db
                </template>
            </el-table-column>

            <el-table-column
                    label="Teljesített"
                    prop="accomplished_stock"
                    align="right"
            >
                <template slot-scope="scope">
                    {{ scope.row.accomplished_stock }} db
                </template>
            </el-table-column>

        </el-table>
    </div>

</template>

<script>
    export default {
        name: "CustomerOrder",

        data() {
            return {
            }
        },

        computed: {
            storages() {
                return this.$store.getters['storage/storages'];
            },

            data() {
                return this.$store.getters['storageStockReport/customerOrders'];
            },

            storage: {
                get() {
                    return this.$store.state.storageStockReport.storageInDialog;
                },
                set(value) {
                    this.$store.commit('storageStockReport/setStorageInDialog', value);
                    this.$store.dispatch('storageStockReport/fetchUnaccomplished');
                }
            },

            loading() {
                return this.$store.state.storageStockReport.supplierOrderLoading;
            }
        },

        methods: {
            handleStorageChange() {
                this.fetchData();
            },
        },
    }
</script>

<style scoped>

</style>
